import { DatadogRUM } from '@user-portal/datadog-rum';
import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IUserProfileResponse } from 'api/components/User/types';

import { notifyError } from 'store/notifications/actions';
import {
    getCurrentUserError,
    getCurrentUserRequest,
    getCurrentUserSuccess,
    postGoogleAnalyticsId,
    setUserAbTestPercentage,
} from 'store/user/actions';

import { setIdToTheProvider } from 'services/Analytics/helpers';

import { userAPIResponseTransformer } from 'helpers/api';
import { getUserPercentForABTest } from 'helpers/getUserPercentForABTest';

import { waitForGetUserWebAnalytics } from './helpers';

export function* getCurrentUser({ payload }: ReturnType<typeof getCurrentUserRequest>) {
    const { onSuccess, onError } = payload ?? {};

    try {
        const userData: IUserProfileResponse = yield call(api.user.getUser);

        yield call(waitForGetUserWebAnalytics);

        yield call(setIdToTheProvider, userData.id);

        yield call(DatadogRUM.setUser, userData.id);

        yield put(postGoogleAnalyticsId());

        yield put(getCurrentUserSuccess(userAPIResponseTransformer(userData)));

        const abTestPercentage: number = yield call(getUserPercentForABTest, userData.user_id);

        yield put(setUserAbTestPercentage(abTestPercentage));

        if (onSuccess) yield call(onSuccess, userData);
    } catch (error: unknown) {
        yield put(getCurrentUserError());
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));

        if (onError) yield call(onError, error);
    }
}
